// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search--banner[data-v-4b079400]{position:relative;width:100%;margin-bottom:16px}.search--banner img[data-v-4b079400]{cursor:pointer;width:100%;max-width:340px;object-fit:contain;border-radius:16px}@media only screen and (max-width: 768px){.search--banner img[data-v-4b079400]{max-width:initial}}.search--banner .filler[data-v-4b079400]{min-height:400px}@media only screen and (max-width: 768px){.search--banner .filler[data-v-4b079400]{min-height:150px}}", ""]);
// Exports
module.exports = exports;
